// extracted by mini-css-extract-plugin
export var icon = "resume-module--icon--13b95";
export var resumeWrapper = "resume-module--resumeWrapper--851f3";
export var wrapper = "resume-module--wrapper--78cd9";